/**
 * @flow
 * @relayHash 8750ab14ccaa36e31d2cabc09771c9e9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TenantLoaderFragment_viewer$ref = any;
export type TenantLoaderQueryVariables = {|
  first?: ?number,
  offset?: ?number,
|};
export type TenantLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TenantLoaderFragment_viewer$ref
  |}
|};
export type TenantLoaderQuery = {|
  variables: TenantLoaderQueryVariables,
  response: TenantLoaderQueryResponse,
|};
*/


/*
query TenantLoaderQuery(
  $first: Int
  $offset: Int
) {
  viewer {
    ...TenantLoaderFragment_viewer_21Sbsv
    id
  }
}

fragment TenantLoaderFragment_viewer_21Sbsv on Query {
  tenants(first: $first, offset: $offset) {
    edges {
      node {
        id
        name
        firstName
        lastName
        email
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TenantLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TenantLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TenantLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenants",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TenantNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TenantNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "TenantLoaderQuery",
    "id": null,
    "text": "query TenantLoaderQuery(\n  $first: Int\n  $offset: Int\n) {\n  viewer {\n    ...TenantLoaderFragment_viewer_21Sbsv\n    id\n  }\n}\n\nfragment TenantLoaderFragment_viewer_21Sbsv on Query {\n  tenants(first: $first, offset: $offset) {\n    edges {\n      node {\n        id\n        name\n        firstName\n        lastName\n        email\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0913a42f66d7d562f91508c4689124a6';
module.exports = node;
